import http from '../http'

export const login = data => {
  return http.request({
    url: '/auth/login',
    data,
    method: 'post'
  })
}

export const logOut = data => {
  return http.request({
    url: '/auth/logOut',
    method: 'post'
  })
}

export const modifyPassword = data => {
  return http.request({
    url: '/auth/modifyPassword',
    method: 'post',
    data
  })
}
